// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__lSWwn","signatureButtonsRight":"ModalSign_signatureButtonsRight__ALQS6"};